import React, { Component } from 'react';
import { Descriptions, Spin, List } from 'antd';
import { withRouter, } from 'react-router-dom';
import unImg from '../../assets/img/database/un.png'
import caImg from '../../assets/img/database/ca.png'
import './index.css'
import { detailAPI } from '../../api/senatorSearch.js'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'

class senatorDetail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dataSource: [],
			currCountry: this.props.match.params.country ? this.props.match.params.country : '',
			countrySrc: '',
			currId: '',
			tbName: '',
		}
	}

	componentDidMount() {
		let query_params = new URLSearchParams(this.props.location.search);
		let selType = query_params.get("tbName");
		this.setState({
			countrySrc: { 'ca': caImg, 'eu': unImg }[this.state.currCountry],
			currCountry: this.props.match.params.country,
			currId: this.props.match.params.id,
			tbName: selType
		},
			() => { this.fetchDetail() })
	}

	fetchDetail = () => {
		const { currCountry, currId, tbName } = this.state;
		var params = {
			auto_id: currId,
			tb_name: tbName
		}
		detailAPI(currCountry, params)
			.then(res => {
				var data = res.data.data
				this.setState({ dataSource: data })
			})
	}

	render() {

		const FocusList = ({ focusData }) => {
			try {
				// 1. 处理空值或"NONE"情况
				if (!focusData || focusData === "NONE") {
					return <span></span>;
				}

				// 2. 解析JSON字符串（处理单引号问题）
				const parsedData = typeof focusData === 'string'
					? JSON.parse(focusData.replace(/'/g, '"')) // 将单引号替换为双引号
					: focusData;

				// 3. 验证数据格式
				if (!Array.isArray(parsedData)) {
					return <span></span>;
				}

				// 4. 过滤空数据并取前10项
				const validItems = parsedData
					.filter(item => item && typeof item === 'object' && Object.keys(item).length > 0)
					.slice(0, 10);

				// 5. 渲染列表
				return validItems.length > 0 ? (
					<List
						size="small"
						dataSource={validItems}
						renderItem={(item, index) => {
							const [key, value] = Object.entries(item)[0] || [`领域-${index}`, ''];
							return (
								<List.Item key={`${key}-${index}`}>
									{key}:{' '}{value || '0'}
								</List.Item>
							);
						}}
					/>
				) : (
					<span></span>
				);
			} catch (e) {
				console.error('解析关注领域数据失败:', e);
				return <span></span>;
			}
		};

		const MeetsList = ({ MeetsData }) => {
			try {

				// 1. 处理空值或"NONE"情况

				if (!MeetsData || MeetsData === "NONE") {
					return <span></span>;
				}

				const parsedData = typeof MeetsData === 'string'
					? JSON.parse(MeetsData) // 将单引号替换为双引号
					: MeetsData;

				const validItems = parsedData.filter(item => item && typeof item === 'object' && Object.keys(item).length > 0)
					.slice(0, 10);

				return validItems.length > 0 ? (
					<List
						size="small"
						dataSource={validItems}
						renderItem={(item, index) => (
							<List.Item key={index} style={{ padding: '4px 0' }}>
								<div style={{ width: '100%' }}>
									<div>
										{item.url ? (
											<a href={item.url} target="_blank" rel="noopener noreferrer">
												{item.title || '无标题记录'}
											</a>
										) : (
											<span>{item.title || '无标题记录'}</span>
										)}
									</div>
									<div style={{ color: '#888', fontSize: '12px' }}>
										{item.datestr || '无日期信息'}
									</div>
								</div>
							</List.Item>
						)}
					/>
				) : (
					<span></span >
				);
			} catch (e) {
				console.error('解析关注领域数据失败:', e);
				return <span></span>;
			}
		};

		const MediaList = ({ MediaData }) => {
			try {

				// 1. 处理空值或"NONE"情况
				console.log('原始数据', MediaData)
				if (!MediaData || MediaData === "NONE") {
					return <span></span>;
				}

				const parsedData = typeof MediaData === 'string'
					? JSON.parse(MediaData) // 将单引号替换为双引号
					: MediaData;

				const validItems = parsedData.filter(item => item && typeof item === 'object' && Object.keys(item).length > 0)
					.slice(0, 10);

				return validItems.length > 0 ? (
					<List
						size="small"
						dataSource={validItems}
						renderItem={(item, index) => (
							<List.Item key={index} style={{ padding: '4px 0' }}>
								<div style={{ width: '100%' }}>
									<div>
										{item.url ? (
											<a href={item.url} target="_blank" rel="noopener noreferrer">
												{item.title || '无标题记录'}
											</a>
										) : (
											<span>{item.title || '无标题记录'}</span>
										)}
									</div>
									<div style={{ color: '#888', fontSize: '12px' }}>
										{item.datestr || '无日期信息'}
									</div>
								</div>
							</List.Item>
						)}
					/>
				) : (
					<span></span >
				);
			} catch (e) {
				console.error('解析近期动态数据失败:', e);
				return <span></span>;
			}
		};

		const { dataSource, currCountry } = this.state;

		const euEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.name}</Descriptions.Item>
				<Descriptions.Item label="国家(Country)">{dataSource.country}</Descriptions.Item>
				{/* <Descriptions.Item label="党派(Faction)">{dataSource.faction}</Descriptions.Item> */}
				<Descriptions.Item label="党团(Group)">{dataSource.group}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const caEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.name}</Descriptions.Item>
				<Descriptions.Item label="党派(Affiliation)">{dataSource.faction}</Descriptions.Item>
				<Descriptions.Item label="选区(Constituency)">{dataSource.constituency}</Descriptions.Item>
				<Descriptions.Item label="省份(Province)">{dataSource.province}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const usEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.name}</Descriptions.Item>
				<Descriptions.Item label="党派(Party)">{dataSource.party}</Descriptions.Item>
				<Descriptions.Item label="州(State)">{dataSource.state}</Descriptions.Item>
				<Descriptions.Item label="出生日期(Birthdate)">{dataSource.birthdate}</Descriptions.Item>
				<Descriptions.Item label="任期(Served)">{dataSource.served}</Descriptions.Item>
				<Descriptions.Item label="议员推特"><a target="_blank" href={dataSource.xurl}>{dataSource.xurl}</a></Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
				<Descriptions.Item label="近期动态" ><MediaList MediaData={dataSource.media} /></Descriptions.Item>
				<Descriptions.Item label="参与议会" ><MeetsList MeetsData={dataSource.meets} /></Descriptions.Item>
				<Descriptions.Item label="重点关注" ><FocusList focusData={dataSource.focus} /></Descriptions.Item>

			</Descriptions>
		)
		const ukEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.name}</Descriptions.Item>
				<Descriptions.Item label="党派(Party)">{dataSource.party}</Descriptions.Item>
				<Descriptions.Item label="选区(Constituency)">{dataSource.constituency}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)
		const plEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.name}</Descriptions.Item>
				<Descriptions.Item label="党派(Lista)">{dataSource.lista}</Descriptions.Item>
				<Descriptions.Item label="会社(Klub/Koło)">{dataSource.klub}</Descriptions.Item>
				<Descriptions.Item label="选区(Okręg wyborczy)">{dataSource.okreg}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)
		const trEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.name}</Descriptions.Item>
				<Descriptions.Item label="党派(Parti)">{dataSource.parti}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)
		const frEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.member}</Descriptions.Item>
				<Descriptions.Item label="党团(Groupe)">{dataSource.fraction}</Descriptions.Item>
				<Descriptions.Item label="省份(Département)">{dataSource.département}</Descriptions.Item>
				<Descriptions.Item label="选区(Circonscription)">{dataSource.circonscription}</Descriptions.Item>
				<Descriptions.Item label="议院(Assemblée)">{dataSource.category}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)
		const geEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.mitglieder}</Descriptions.Item>
				<Descriptions.Item label="党派(Fraktion)">{dataSource.partei}</Descriptions.Item>
				<Descriptions.Item label="州(Bundesland)">{dataSource.bundesland}</Descriptions.Item>
				<Descriptions.Item label="职务(Funktion)">{dataSource.funktion}</Descriptions.Item>
				<Descriptions.Item label="选区(Wahlkreis)">{dataSource.wahlkreise}</Descriptions.Item>
				<Descriptions.Item label="议院(Parlament)">{dataSource.category}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)
		let pkCategory = ''
		if (dataSource.chamber && dataSource.chamber === 'Se') {
			pkCategory = 'Senate'
		}
		if (dataSource.chamber && dataSource.chamber === 'Na') {
			pkCategory = 'National Assembly'
		}
		const pkEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.member}</Descriptions.Item>
				<Descriptions.Item label="议院(Chamber)">{pkCategory}</Descriptions.Item>
				<Descriptions.Item label="任期(Tenure)">{dataSource.tenure}</Descriptions.Item>
				<Descriptions.Item label="党派(Party)">{dataSource.fraction}</Descriptions.Item>
				<Descriptions.Item label="省份(Province)">{dataSource.province}</Descriptions.Item>
				<Descriptions.Item label="选区(Constituency)">{dataSource.constituency}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)
		const sgEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.member}</Descriptions.Item>
				<Descriptions.Item label="选区(Constituency)">{dataSource.constituency}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)
		const nzEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.member}</Descriptions.Item>
				<Descriptions.Item label="党派(Party)">{dataSource.fraction}</Descriptions.Item>
				<Descriptions.Item label="选区(Electorate)">{dataSource.electorate}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		let zaCategory = ''
		if (dataSource.chamber && dataSource.chamber === 'HP') {
			zaCategory = 'National Assembly'
		}
		if (dataSource.chamber && dataSource.chamber === 'Bills') {
			zaCategory = 'National Council of Provinces'
		}
		const zaEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.member}</Descriptions.Item>
				<Descriptions.Item label="议院(Chamber)">{zaCategory}</Descriptions.Item>
				<Descriptions.Item label="党派(Party)">{dataSource.fraction}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		// let atCategory = ''
		// if (dataSource.chamber && dataSource.chamber == 'BR'){
		// 	atCategory = 'Federal Parliament'
		// }
		// if (dataSource.chamber && dataSource.chamber == 'NR'){
		// 	atCategory = 'National Parliament'
		// }
		const atEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.representative}</Descriptions.Item>
				<Descriptions.Item label="议院(Parlament)">{dataSource.chamber}</Descriptions.Item>
				<Descriptions.Item label="党派(Fraktion)">{dataSource.fraction}</Descriptions.Item>
				{/* <Descriptions.Item label="立法期(Legislation Period)">{dataSource.legislationperiod}</Descriptions.Item> */}
				<Descriptions.Item label="州(Bundesland)">{dataSource.state}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		let indiaCategory = ''
		if (dataSource.chamber && dataSource.chamber === 'LS') {
			indiaCategory = 'Lok Sabha'
		}
		if (dataSource.chamber && dataSource.chamber === 'RS') {
			indiaCategory = 'Rajya Sabha'
		}
		const indiaEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.member}</Descriptions.Item>
				<Descriptions.Item label="议院(Sansad)">{indiaCategory}</Descriptions.Item>
				<Descriptions.Item label="党派(Party)">{dataSource.fraction}</Descriptions.Item>
				<Descriptions.Item label="邦(State)">{dataSource.state}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const myEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.member}</Descriptions.Item>
				<Descriptions.Item label="议院(Dewan)">{dataSource.category}</Descriptions.Item>
				<Descriptions.Item label="党派(Parti)">{dataSource.fraction}</Descriptions.Item>
				<Descriptions.Item label="任命(Lantikan)">{dataSource.state}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const ruEle = (
			<Descriptions title="" column={1} bordered labelStyle={{ fontWeight: 'bold', width: 200 }}>
				<Descriptions.Item label="议员(Member)">{dataSource.name}</Descriptions.Item>
				<Descriptions.Item label="议院(Палата)">{dataSource.category}</Descriptions.Item>
				<Descriptions.Item label="党团(Фракции)">{dataSource.Фракция}</Descriptions.Item>
				<Descriptions.Item label="州(Области)">{dataSource.Регион}</Descriptions.Item>
				<Descriptions.Item label="出生日期(Дата Рождения">{dataSource.born}</Descriptions.Item>
				<Descriptions.Item label="就任时间(Дата Наделения Полномочнями)">{dataSource.tookOffice}</Descriptions.Item>
				<Descriptions.Item label="卸任时间(Срок Окончания Полномочий)">{dataSource.termEnds}</Descriptions.Item>
				<Descriptions.Item label="议员主页"><a target="_blank" href={dataSource.url}>{dataSource.url}</a></Descriptions.Item>
			</Descriptions>
		)

		const contentEle = Object.keys(dataSource).length > 0 ? {
			'ca': caEle, 'ru': ruEle, 'eu': euEle, 'us': usEle, 'uk': ukEle, 'pl': plEle, 'tr': trEle, 'fr': frEle, 'ge': geEle,
			'pk': pkEle, 'sg': sgEle, 'nz': nzEle, 'za': zaEle, 'at': atEle, 'india': indiaEle, 'my': myEle
		}[currCountry]
			: (
				<div style={{ width: '100%', textAlign: 'center', paddingTop: '10%' }}>
					<Spin tip="数据加载中..." style={{ margin: 'auto' }}></Spin>
				</div>
			)
		return (
			<div style={{ margin: '40px 15%', }}>
				<MyBreadcrumb urls={[
					{
						url: '/database/senator/' + currCountry, breadcrumbName: {
							'ca': '加拿大议员', 'ru': '俄罗斯议员', 'eu': '欧洲议员', 'us': '美国议员', 'uk': '英国议员', 'pl': '波兰议员', 'tr': '土耳其议员', 'fr': '法国议员', 'ge': '德国议员',
							'pk': '巴基斯坦议员', 'sg': '新加坡议员', 'nz': '新西兰议员', 'za': '南非议员', 'at': '奥地利议员', 'india': '印度议员', 'my': '马来西亚议员'
						}[currCountry] + ''
					},
					{ breadcrumbName: '详情' },
				]} />
				{contentEle}
			</div>
		);
	}
}

export default withRouter(senatorDetail)
